import React, { useCallback } from "react";
import { Radio as MUIRadio } from "@material-ui/core";
import type { FC } from "react";
import { useStyles } from "./Radio.styles";
import type { IRadioProps } from "./Radio.types";

export const Radio: FC<IRadioProps> = (props) => {
  const classes = useStyles();
  const { checked, onChangeChecked, disabled } = props;

  const handleChangeChecked = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      onChangeChecked(checked);
    },
    [onChangeChecked]
  );

  return (
    <MUIRadio classes={{ root: classes.rootCheckbox }} color="primary" onChange={handleChangeChecked} checked={checked} disabled={disabled} />
  );
};
